var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", [_vm._v("Create New View")]),
        _c("div", { class: _vm.$style.subHeader }, [
          _vm._v("Create new view for your hotel directory."),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody hotel-directory",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "rb-input",
            { attrs: { "for-id": "name", error: _vm.$showError("name") } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("View Name"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.view,
                    expression: "data.view",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:100",
                    expression: "'required|max:100'",
                  },
                ],
                staticClass: "rbInput",
                attrs: {
                  id: "name",
                  type: "text",
                  name: "name",
                  autofocus: "",
                  maxlength: "100",
                  placeholder: "view name",
                  "data-vv-as": "view name",
                },
                domProps: { value: _vm.data.view },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.data, "view", $event.target.value)
                  },
                },
              }),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
          _c("button", { staticClass: "rbButton mainButton" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
            _vm._v(" Create View "),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }